module.exports = __webpack_public_path__ + "static/media/ytcracker.fc3a9c5c.png";